"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.querySalesPersonByEmail = exports.queryAllSalesPersons = void 0;
const types_1 = require("../../types");
exports.queryAllSalesPersons = `
  query allSalesPersonsByDealerId($dealerId: String) {
    allSalesPersonsByDealerId(dealerId: $dealerId) {
      ${types_1.salesPersonFields}
    }
  }
`;
exports.querySalesPersonByEmail = `
  query findSalesPersonByEmail($email: String!) {
    findSalesPersonByEmail(email: $email) {
      ${types_1.salesPersonFields}
    }
  }
`;
//# sourceMappingURL=sales-person.js.map